<template>
  <div class="email">
    <input type="email" :id="Math.random().toString(36).substring(7)" :class="errors.has('email') ? 'error' : ''" :placeholder="labels['email']" name="email" v-validate="'required|email'" @input="updateEmail" :value="email">
    <small v-if="month" class="help unsubscribe" v-html="labels['unsubscribeTip']('/unsubscribe')"></small>
    <small v-show="errors.has('email')" class="help error">{{ errors.first('email') }}</small>
    <small v-show="this.suggested" class="suggestion">{{ labels['emailSuggestion'] }} <span class="email" @click="acceptSuggestion">{{ this.suggested }}</span>?</small>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Mailcheck from 'mailcheck'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

export default {
  data: function () {
    return {
      suggested: null
    }
  },
  inject: ['$validator'],
  computed: mapState({
    email: state => state.donation.email,
    lang: state => state.language,
    labels: state => LABELS[state.language],
    month: state => state.donation.month
  }),
  methods: {
    updateEmail (e) {
      const prop = 'email'
      const value = e.target.value
      const change = { prop, value }
      this.$store.commit('updateDonation', change)

      Mailcheck.run({
        email: value,
        suggested: suggestion => {
          this.suggested = suggestion.full
        }
      })
    },
    acceptSuggestion (e) {
      this.$store.commit('updateDonation', {
        prop: 'email',
        value: this.suggested
      })
      this.suggested = null
    }
  },
  mounted () {
    const lang = this.lang
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
  .oi-donate .suggestion {
    position: relative;
    top: -10px;
    font-size: 12px;
  }
  .oi-donate .suggestion .email {
    color: #ef4e23;
    cursor: pointer;
  }
  .oi-donate .email small.help {
    margin: 0 0 5px;
    position: relative;
    font-size: 12px;
    top: -5px;
  }
  .oi-donate .email input {
    margin-bottom: 10px;
  }
  .oi-donate .email .unsubscribe {
    font-size: 12px;
    display: block;
  }
</style>
